mutation verificationUpdate($uuid: String, $full_name: String, $document_country: String, $date_of_birth: String, $document_type: String, $document_number: String) {
    verificationUpdate(uuid: $uuid, full_name: $full_name, document_country: $document_country, date_of_birth: $date_of_birth, document_type: $document_type, document_number: $document_number) 
}
